import { BlogShared } from './../../general/shared/blog-shared';
import { ReferralUser } from './../../../core/model/api-response/profile-response-model';
import { SnackBarService } from './../../../data/repository/utils-repository/snack-bar.service';
import { UserDataService } from './../../../data/repository/user-repository/user-data.service';
import { ProfileService } from 'src/app/data/repository/profile-repository/profile.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-referral',
  templateUrl: './referral.component.html',
  styleUrls: ['./referral.component.scss'],
})
export class ReferralComponent implements OnInit {
  referralCode = '';
  referralUsers: ReferralUser[] = [];

  selectedUsername = '';
  profileId = 10;
  showProfile = false;

  constructor(
    private profileService: ProfileService,
    private userDataService: UserDataService,
    private snackBarService: SnackBarService,
    private blogShared: BlogShared
  ) {
    this.userDataService.getUser().then((user) => {
      this.referralCode = user.referralCode;
    });
  }

  ngOnInit() {
    this.profileService.getReferralUsers().then((res) => {
      if (res.isSuccess()) {
        this.referralUsers = res.getData().getReferralUsers();
      } else {
        this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
      }
    });
  }

  close() {
    this.profileService.goToMain();
  }

  userSelected(user: ReferralUser) {
    if (user.username && user.username !== '') {
      this.selectedUsername = user.username;
      this.blogShared.blogZIndex++;
      this.profileId = this.blogShared.blogZIndex;
      this.showProfile = true;
      setTimeout(() => {
        document.getElementById('profilePage10').style.zIndex =
          this.blogShared.blogZIndex.toString();
        document.getElementById('profilePage10').style.right = '0';
      }, 100);
    } else {
      this.snackBarService.showSnackBar('این کاربر هنوز پروفایل تریبون ندارد.');
    }
  }

  closeProfile() {
    this.blogShared.blogZIndex--;
    document.getElementById('profilePage10').style.right = '100%';
    setTimeout(() => {
      this.showProfile = false;
    }, 300);
  }

  copyReferralCode() {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.referralCode;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.snackBarService.showSnackBar('کد معرف کپی شد');
  }

  shareReferralCode() {
    let newVariable: any;
    newVariable = window.navigator;
    if (newVariable && newVariable.share) {
      newVariable
        .share({
          text:
            'سلامتی را با «بنتو» تجربه کنید.' +
            '\n' +
            'با بنتو می‌توانید متناسب با مشخصات و سلیقه خود، برنامه غذایی دریافت کنید و به وزن ایده‌آل برسید.' +
            '\n' +
            'اپلیکیشن بنتو را از لینک زیر دریافت کنید:' +
            '\n' +
            'http://bentoapp.info/download' +
            '\n' +
            'کد معرف: ' +
            this.referralCode,
        })
        .catch((e) => {
          this.snackBarService.showSnackBar('خطا در اشتراک گذاری');
        });
    } else {
      // this.snackBarService.showSnackBar('اشتراک گذاری در جست‌و‌جوگر شما پشتیبانی نمیشود');
      const selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = this.referralCode;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
      this.snackBarService.showSnackBar('کد دعوت دوستان کپی شد');
    }
  }
}
